import { render, staticRenderFns } from "./ClientStatusPieChart.vue?vue&type=template&id=e852ffd4&scoped=true&"
import script from "./ClientStatusPieChart.vue?vue&type=script&lang=js&"
export * from "./ClientStatusPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e852ffd4",
  null
  
)

export default component.exports